import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UrunGrup} from '../model/urun-grup';

@Component({
  selector: 'app-urun-grup-liste',
  templateUrl: './urun-grup-liste.component.html',
  styleUrls: ['./urun-grup-liste.component.css']
})
export class UrunGrupListeComponent implements OnInit {
  urunGruplar: UrunGrup[] = null;

  constructor() {
  }

  @Input()
  public set source(source: UrunGrup[]) {
    this.urunGruplar = source;
  }

  @Output() view = new EventEmitter<UrunGrup>();
  @Output() delete = new EventEmitter<UrunGrup>();


  ngOnInit(): void {
  }

  incele(k: UrunGrup) {
    this.view.emit(k);
  }

  kaldir(k: UrunGrup) {
    this.delete.emit(k);
  }
}
